var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiosk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7544 1V3.31581C22.7544 4.59481 21.7913 5.63192 20.603 5.63192C19.4156 5.63192 18.4525 4.59511 18.4525 3.31581C18.4525 4.59481 17.4895 5.63192 16.3012 5.63192C15.1138 5.63192 14.1507 4.59511 14.1507 3.31581C14.1507 4.59481 13.1877 5.63192 11.9994 5.63192C10.8114 5.63192 9.84834 4.59511 9.84834 3.31581C9.84834 4.59481 8.88529 5.63192 7.69729 5.63192C6.50929 5.63192 5.54624 4.59511 5.54624 3.31581C5.54624 4.59481 4.58319 5.63192 3.39519 5.63192C2.20719 5.63192 1.24414 4.59511 1.24414 3.31581V1H22.7544V1Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39648 5.62891V13.2081",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6045 5.62891V13.2081",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.2109H1V21.9481H23V13.2109Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 21.9492V23.0017",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.876 21.9492V23.0017",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/kiosk.30be11787aa9df16d67ff2eebbcc8938.svg";
export { ForwardRef as ReactComponent };